import NotificationDto from '@/projectRoot/api-client/interfaces/models/content/Notification.dto';
import SwiperCarousel from '../../../common/swiper/SwiperCarousel';
import style from './notifications.module.scss';

interface Props {
    notifications: NotificationDto[];
    classes?: string[];
}

const Notifications = ({notifications, classes = []}: Props) => {
    return (
        <SwiperCarousel sliderId='header_notifications' sliderClassName={`${style.notifications} ${classes.join(' ')}`} autoplayOptions={{delay: 4000}} autoplay={notifications.length > 1 ? true : false} dots={false}>
            {
                notifications.map(notification => 
                    !notification.call_to_action_url || notification.call_to_action_url == '' ? 
                        <div className={style.notification} dangerouslySetInnerHTML={{__html: notification.description}} />
                        :
                        <a key={notification.id}   
                            className={style.notification} 
                            href={notification.call_to_action_url}
                        >
                            {notification.description}
                        </a>  
                )
            }
        </SwiperCarousel>
    )
};

export default Notifications;
